import { getCookie, setCookie } from "cookies-next/client";
import { useState } from "react";

export default function useCookieStore<T>(key: string, initialValue: T): [T, (value: T | ((val: T) => T)) => void] {
  // Get initial value from cookie or use initialValue
  const [storedValue, setStoredValue] = useState<T>(() => {
    if (typeof window === "undefined") return initialValue;

    try {
      const item = getCookie(key);
      return item ? JSON.parse(item) : initialValue;
    } catch (error) {
      console.warn(`Error reading cookie value for key "${key}":`, error);
      return initialValue;
    }
  });

  // Return a wrapped version of setCookie that persists the new value
  const setValue = (value: T | ((val: T) => T)) => {
    try {
      // Allow value to be a function for same API as useState
      const valueToStore = value instanceof Function ? value(storedValue) : value;

      // Save state
      setStoredValue(valueToStore);

      // Save to cookies
      if (typeof window !== "undefined") {
        setCookie(key, JSON.stringify(valueToStore));
      }
    } catch (error) {
      // Allow value to be a function for same API as useState
      const valueToStore = value instanceof Function ? value(storedValue) : value;

      setCookie(key, JSON.stringify(typeof valueToStore == "string" ? `"${valueToStore}"` : valueToStore));
    }
  };

  return [storedValue, setValue];
}
